export default "__VITE_ASSET__a7be02f0__"